// extracted by mini-css-extract-plugin
export default {"certifications":"Certification_certifications__qcdvE","badge":"Certification_badge__QIue2"};